// useEventListener.js
import { useEffect } from "react";

export function useEvent(eventName, handler) {
  useEffect(() => {
    if (!window || !window.addEventListener) return;

    const eventListener = (event) => handler(event);
    window.addEventListener(eventName, eventListener);

    return () => {
      window.removeEventListener(eventName, eventListener);
    };
  }, [eventName, handler]);
}

export const dispatchEvent = (eventName, detail) => {
  if (!window || !window.dispatchEvent) return;
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};
